import React, { FunctionComponent } from 'react'

import { LvApiResponse, LvGeometryApiResponse } from '../../../common/lvTypes'
import { LvDetailDrawerTitle } from '../LvDetailDrawerTitle/LvDetailDrawerTitle'
import { LvDetailOwnershipProperties } from '../LvDetailOwnershipProperties/LvDetailOwnershipProperties'
import { LvDetailSidebarImage } from '../LvDetailSidebarImage/LvDetailSidebarImage'
import { LvDetailSidebarLv } from '../LvDetailSidebarLv/LvDetailSidebarLv'
import { LvDetailSidebarRestriction } from '../LvDetailSidebarRestriction/LvDetailSidebarRestriction'
import { PropertyDetailLastNote } from '../PropertyDetailLastNote/PropertyDetailLastNote'

export interface LvDetailDrawerBodyProps {
  lvData?: LvApiResponse
  geometryData?: LvGeometryApiResponse
}
const buildingProps = {
  compactView: true,
  hideArea: true,
  drawerTarget: false,
  target: '_blank',
}
const areaProps = {
  compactView: true,
  hideBuilding: true,
  drawerTarget: false,
  target: '_blank',
}
const unitProps = {
  compactView: true,
  hideBuilding: true,
  drawerTarget: false,
  target: '_blank',
}

export const LvDetailDrawerBody: FunctionComponent<LvDetailDrawerBodyProps> =
  props => {
    if (!props.lvData || !props.geometryData) {
      return null
    }
    return (
      <div className="flex flex-col space-y-3 mb-4">
        <LvDetailDrawerTitle
          cadastralName={props.lvData?.katastralniUzemi?.nazev}
        />
        <LvDetailSidebarImage isDrawer geometryData={props.geometryData} />

        <div className="flex flex-col space-y-8">
          <LvDetailSidebarRestriction
            isDrawer
            properties={props.lvData?.nemovitosti}
          />

          <PropertyDetailLastNote
            isDrawer
            lvCode={props.lvData?.katastralniUzemi?.kod}
            lvNumber={props.lvData?.lv}
          />
          <LvDetailSidebarLv
            isDrawer
            lvNumber={props.lvData?.lv}
            cadastralArea={props.lvData?.katastralniUzemi}
          />

          <LvDetailOwnershipProperties
            properties={props.lvData?.nemovitosti}
            propertiesGeometry={props.geometryData}
            buildingProps={buildingProps}
            areaProps={areaProps}
            unitProps={unitProps}
          />
        </div>
      </div>
    )
  }
